import React, { useRef } from "react";
import "./contact.scss";
import { IoLocationSharp } from "react-icons/io5";
import emailjs from "@emailjs/browser";
import { FaWhatsapp } from "react-icons/fa";

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(  
        "service_a0f6obr",
        "template_0hv31k9", 
        e.target,
        "pLd3QhrFmeSifW3Ka"
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
          console.log(result.text);
        },
        (error) => {
          alert("Failed to send message. Please try again.");
          console.log(error.text);
        }
      );

    e.target.reset(); // Reset form fields after submission
  };

  return (
    <div className="contact-page">
      <h1 className="contact-title">Contact Us</h1>
      <p className="contact-subtitle">
        "We’re here to assist you with any questions or inquiries. Feel free to reach out to us anytime."
      </p>

      <div className="contact-container">
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <p>
            "Feel free to contact us for any queries, assistance, or information. We’re here to help you plan your perfect adventure."
          </p>
          <div className="info-item">
            <span className="icon">
              <IoLocationSharp />
            </span>
            <p>Skardu, Gilgit-Baltistan, Pakistan</p>
          </div>
          <div className="info-item">
          <FaWhatsapp />
            <span className="icon"></span>
            <p>+971 55 593 6448</p>
          </div>
          <div className="info-item">
            <span className="icon">📞</span>
            <p>+923 49 158 9717</p>
          </div>
          <div className="info-item">
            <span className="icon">📧</span>
            <p>info@worldadveturestours.com</p>
          </div>

          <div className="social-links">
            <h3>Follow Us</h3>
            <div className="icons">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="contact-form">
          <h2>Send a Message</h2>
          <form ref={form} onSubmit={sendEmail}>
            <input type="text" name="user_name" placeholder="Name" required />
            <input type="email" name="user_email" placeholder="E-mail address" required />
            <textarea name="message" placeholder="Message" rows="4" required></textarea>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
